import { render, staticRenderFns } from "./EditComputeProduct.vue?vue&type=template&id=4bd36022&scoped=true"
import script from "./EditComputeProduct.vue?vue&type=script&lang=js"
export * from "./EditComputeProduct.vue?vue&type=script&lang=js"
import style0 from "./EditComputeProduct.vue?vue&type=style&index=0&id=4bd36022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd36022",
  null
  
)

export default component.exports